import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-qian-chuan",
  "use": "icon-qian-chuan-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-qian-chuan\"><g><path d=\"M0,2.66667C0,1.19391,1.19391,0,2.66667,0L21.3333,0C22.8061,0,24,1.19391,24,2.66667L24,21.3333C24,22.8061,22.8061,24,21.3333,24L2.66667,24C1.19391,24,0,22.8061,0,21.3333L0,2.66667ZM14.5853,6.20667C14.1147,5.02933,12.428,5.096,12.0493,6.30533L9.71334,13.78L9.196,12.744C8.96768,12.288,8.50164,12,7.992,12L5.33333,12C4.59695,12,4,12.597,4,13.3333C4,14.0697,4.59695,14.6667,5.33333,14.6667L7.176,14.6667L8.792,17.9C9.33467,18.984,10.9213,18.856,11.2827,17.7L13.488,10.6427L14.7587,13.82C14.9627,14.332,15.4587,14.6667,16.0093,14.6667L18.6667,14.6667C19.403,14.6667,20,14.0697,20,13.3333C20,12.597,19.403,12,18.6667,12L16.9027,12L14.5853,6.20667Z\" fill-rule=\"evenodd\" fill=\"#6C5FFC\" fill-opacity=\"1\" style=\"mix-blend-mode:passthrough\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/qian-chuan.svg
// module id = 8fPb
// module chunks = 119